export function initDropdownMenus() {
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('.po-cat-group-dropdown__trigger');
    if (!trigger) return;

    const vPopper = trigger.closest('.v-popper');
    const popper = vPopper?.querySelector('.v-popper__popper');
    const icon = trigger.querySelector('.po-cat-group-dropdown__icon');

    if (!popper) return;

    const isVisible = popper.classList.contains('v-popper__popper--active');

    document.querySelectorAll('.v-popper__popper').forEach((p) => {
      p.classList.remove('v-popper__popper--active');
      p.style.opacity = '0';
      p.style.visibility = 'hidden';
    });

    document.querySelectorAll('.po-cat-group-dropdown__icon').forEach((i) => {
      i.classList.remove('po-cat-group-dropdown__icon_open');
    });

    if (!isVisible) {
      popper.classList.add('v-popper__popper--active');
      popper.style.opacity = '1';
      popper.style.visibility = 'visible';
      icon?.classList.add('po-cat-group-dropdown__icon_open');
    }
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.v-popper')) {
      document.querySelectorAll('.v-popper__popper').forEach((p) => {
        p.classList.remove('v-popper__popper--active');
        p.style.opacity = '0';
        p.style.visibility = 'hidden';
      });

      document
        .querySelectorAll('.po-cat-group-dropdown__icon')
        .forEach((icon) => {
          icon.classList.remove('po-cat-group-dropdown__icon_open');
        });
    }
  });

  document.addEventListener('click', function (event) {
    const closeBtn = event.target.closest(
      '.po-cat-group-dropdown__close-mobile'
    );
    if (!closeBtn) return;

    const popper = closeBtn.closest('.v-popper__popper');
    if (popper) {
      popper.classList.remove('v-popper__popper--active');
      popper.style.opacity = '0';
      popper.style.visibility = 'hidden';
    }

    const icon = document.querySelector(
      '.po-cat-group-dropdown__icon.po-cat-group-dropdown__icon_open'
    );
    icon?.classList.remove('po-cat-group-dropdown__icon_open');
  });
}
